import axios from 'axios';

/*
const joinUrl = (base, path) =>
  `${String(base).replace(/\/+$/, '')}/${String(path).replace(/^\/+/, '')}`;
*/
/*
async function waitForUrl(
  url,
  { timeoutMs = 10000, intervalMs = 250 } = {}
) {
  const start = Date.now();
  let delay = intervalMs;

  while (Date.now() - start < timeoutMs) {
    try {
      const res = await fetch(url, { method: "HEAD", cache: "no-store" });
      if (res.ok) return true;
    } catch (_) {
      // ignore and retry
    }
    await new Promise((r) => setTimeout(r, delay));
    delay = Math.min(delay * 1.6, 1000); // gentle backoff
  }
  return false;
} */
/*
async function waitForUrl(url, { timeoutMs = 50000, intervalMs = 600 } = {}) {
  const start = Date.now();
  let delay = intervalMs;
  while (Date.now() - start < timeoutMs) {
    try {
      let res = await fetch(url, { method: 'HEAD', cache: 'no-store' });
      if (!res.ok && (res.status === 403 || res.status === 405)) {
        res = await fetch(url, { method: 'GET', cache: 'no-store' });
      }
      if (res.ok) return true;
    } catch {}
    await new Promise((r) => setTimeout(r, delay));
    delay = Math.min(delay * 1.6, 1500);
  }
  return false;
}

*/
/**
 * Generate a PDF on the backend and open it in a new tab once it's ready.
 * Expects backend to return either a string URL or JSON like { url: "https://.../file.pdf" }.
 *
 * @param {string} endpoint  - API endpoint path, e.g. "api/pdf"
 * @param {any} data         - Payload to send to backend
 * @param {boolean} view     - If false, you can plug in your existing blob flow and return early
 */

export const getPdf = async (endpoint, data, view) => {
  /*
        try {
          const url = [process.env.REACT_APP_CMS_URL, endpoint].join('/');
          const response = await axios(url, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
            }
          });
          const data = await response.data;

          return data;
        } catch (error) {
          throw error;
        }

*/

  try {
    //const url = [process.env.REACT_APP_CMS_URL, endpoint].join('/');

    // let response;

    console.log(data);
    /*
      if(view){
        
        let response = await axios(url, {
          method: 'POST',
          data: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
          }
        });
        //let parsedPDFObj = JSON.parse(response);



        const win1 = window.open("about:blank", "_blank");
          if (!win1) {
            // Popups blocked: use current tab after readiness check
            const ready = await waitForUrl(process.env.REACT_APP_CMS_URL + response.data);
            if (ready) window.location.href = process.env.REACT_APP_CMS_URL + response.data;
            else throw new Error("PDF not ready yet. Please try again in a moment.");
            return;
          }

          win1.document.write("<p style='font-family:sans-serif'>Preparing PDF…</p>");
          const ready = await waitForUrl(process.env.REACT_APP_CMS_URL + response.data);
          if (ready) {
            win1.location.replace(process.env.REACT_APP_CMS_URL + response.data);
          } else {
            win1.document.body.innerHTML =
              "<p style='font-family:sans-serif;color:#c00'>Took too long—refresh this tab in a few seconds.</p>";
          }

          return;
/*
      

        const ready = await waitForUrl(process.env.REACT_APP_CMS_URL + response.data);
            if (ready) window.open(process.env.REACT_APP_CMS_URL + response.data);
            else throw new Error("PDF not ready yet. Please try again in a moment.");
            return;

        window.open(process.env.REACT_APP_CMS_URL + response.data);

        return response;
      

          const base = process.env.REACT_APP_CMS_URL;
          const apiUrl = joinUrl(base, endpoint);

          const resp = await fetch(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });

          // Accept JSON or plain text
          //let payload;
          //const contentType = resp.headers.get("content-type") || "";
          /*
          if (contentType.includes("application/json")) {
            payload = await resp.json();
          } else {
            payload = await resp.text();
          }
 */ /*
          const raw = (typeof payload === "object" && payload.url)
            ? payload.url
            : payload;

          const absolute = /^https?:\/\//i.test(raw) ? raw : joinUrl(base, raw);
          const pdfUrl = absolute + (absolute.includes("?") ? `&v=${Date.now()}` : `?v=${Date.now()}`);
*/

    //const absolute = /^https?:\/\//i.test(raw) ? raw : joinUrl(base, raw);
    //const pdfUrl = absolute + (absolute.includes("?") ? `&v=${Date.now()}` : `?v=${Date.now()}`);

    /*
          const raw = typeof payload === "string" ? payload : payload?.url || payload;
          const absolute = /^https?:\/\//i.test(raw) ? raw : joinUrl(base, raw);
          const pdfUrl =
            absolute + (absolute.includes("?") ? `&v=${Date.now()}` : `?v=${Date.now()}`);
*/
    /*
          let payload = await respo.json();  
          // payload might be: { url: "/app/uploads/..." }   ✅ good
          // ...or a string like "{\"url\":\"/app/uploads/...\"}" ❌ double-encoded

          if (typeof payload === "string") {
            try {
              payload = JSON.parse(payload);
            } catch {
              // payload wasn't JSON at all, leave as string
            }
          }

          const raw = payload.url || payload;   // works in both cases
          const absolute = /^https?:\/\//i.test(raw) ? raw : joinUrl(base, raw);
          const pdfUrl = absolute + (absolute.includes("?") ? `&v=${Date.now()}` : `?v=${Date.now()}`);

          // Open a tab first to avoid popup blockers; fill it once the PDF is ready
          const win = window.open("about:blank", "_blank");
          if (!win) {
            // Popups blocked: use current tab after readiness check
            const ready = await waitForUrl(pdfUrl);
            if (ready) window.location.href = pdfUrl;
            else throw new Error("PDF not ready yet. Please try again in a moment.");
            return;
          }

          win.document.write("<p style='font-family:sans-serif'>Preparing PDF…</p>");
          const ready2 = await waitForUrl(pdfUrl);
          if (ready) {
            win.location.replace(pdfUrl);
          } else {
            win.document.body.innerHTML =
              "<p style='font-family:sans-serif;color:#c00'>Took too long—refresh this tab in a few seconds.</p>";
          }
        //}
        */
    /*
          return;
      }else{

        */
    const url = [process.env.REACT_APP_CMS_URL, endpoint].join('/');
    let response = await axios(url, {
      method: 'POST',
      data: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    });

    const productCode =
      data.engine_type +
      '-' +
      data.fitting_codes +
      '-' +
      data.colour_temperature +
      '-' +
      data.drivers +
      '-' +
      data.beam_angles +
      '-' +
      data.bezel_colours +
      '-' +
      data.baffle_colours +
      '-' +
      data.options.join('') +
      '-' +
      data.ref;

    localStorage.setItem('currentProdCode', productCode);

    // If response.data is a Blob without type, rewrap it:
    const contentType = response.headers['content-type'] || 'application/pdf';
    const blob =
      response.data.type === contentType
        ? response.data
        : new Blob([response.data], { type: contentType });

    const buffer = await blob.arrayBuffer();
    const firstBytes = new Uint8Array(buffer.slice(0, 10));
    console.log('First 10 bytes:', firstBytes);

    //const urlStorage = URL.createObjectURL(blob);

    // ✅ log for debug
    console.log('[PDF] Blob:', blob);
    console.log('[PDF] Type:', blob.type);
    console.log('[PDF] Size:', blob.size);

    // ✅ check that the MIME is correct
    if (blob.type !== 'application/pdf') {
      throw new Error('Blob is not a PDF');
    }

    const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(pdfBlob);

    if (view) {
      window.open(blobUrl, '_blank');
      return;
    }

    return blobUrl;
  } catch (error) {
    //Custom 404 error handling when user goes on non-existant products
    if (error?.response?.status === 404) {
      const data = error.response.data;
      return data;
    }
    throw error;
  }
};
